module.exports = __webpack_public_path__ + "static/media/cross.e7b973ca.svg";